import ExhibitionistEmptyState from './ExhibitionistEmptyState';
import ExhibitionistEmptyStateContainer from './ExhibitionistEmptyState.container';

export default ExhibitionistEmptyStateContainer(ExhibitionistEmptyState);
